<template>
  <v-container id="zcierres" tag="section">
    <base-v-component heading="Listado Z Cierres " />
    <base-material-card
      color="indigo"
      icon="mdi-credit-card-multiple"
      inline
      class="px-5 py-3"
    >
      <v-toolbar flat color="white">
        <v-spacer />
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Buscar"
          single-line
          hide-details
        ></v-text-field>
        <v-spacer></v-spacer>
        <v-btn color="success" @click="getZCierres()">
          <v-icon color="white">mdi-autorenew</v-icon>
        </v-btn>
      </v-toolbar>

      <v-data-table
        :headers="headers"
        :items="zcierres"
        :loading="loading"
        :search="search"
        :must-sort="true"
        sort-by="inicio"
        :sort-desc="true"
      >
        <template v-slot:item.acciones="{ item }">
          <v-row>
            <v-spacer />
            <v-tooltip top v-if="!!item.ficheroCierre">
              <template v-slot:activator="{ on }">
                <v-btn
                  class="px-2 ml-1"
                  color="primary"
                  min-width="0"
                  small
                  v-on="on"
                  @click="goPdf(item)"
                >
                  <v-icon small>mdi-file-pdf-box</v-icon>
                </v-btn>
              </template>
              <span>PDF cierre</span>
            </v-tooltip>
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <v-btn
                  class="px-2 ml-1"
                  color="secondary"
                  min-width="0"
                  small
                  v-on="on"
                  @click="$router.push('/admin/negocio/zcierres/' + item.id)"
                >
                  <v-icon small>mdi-eye</v-icon>
                </v-btn>
              </template>
              <span>Ver cierre</span>
            </v-tooltip>
          </v-row>
        </template>
      </v-data-table>
    </base-material-card>
  </v-container>
</template>

<script>
import { mapState } from "vuex";
import { mostrarMoneda } from "@/utils/utils.js";
import moment from "moment";

export default {
  data() {
    return {
      loading: false,
      search: "",
      headers: [
        {
          sortable: false,
          text: "#",
          value: "inicio",
        },

        // {
        //   sortable: false,
        //   text: "Tipo",
        //   value: "tipo",
        // },
        {
          sortable: false,
          text: "Periodo",
          width: "50%",
          value: "periodo",
        },
        {
          sortable: false,
          text: "Total",
          value: "total",
        },
        {
          sortable: false,
          width: "30%",
          text: "Acciones",
          value: "acciones",
          align: "right",
        },
      ],
    };
  },
  computed: {
    ...mapState({
      zcierresBruto: (state) => state.zcierres.zcierres,
    }),
    zcierres() {
      console.log(this.zcierresBruto);
      return this.zcierresBruto.map((c) => {
        let total =
          c.datos && c.datos.resumen && Array.isArray(c.datos.resumen)
            ? //modo antiguo
              c.datos.resumen.find((r) => r.nombre == "TOTALES")
            : //modo nuevo
            c.datos &&
              c.datos.resumen &&
              c.datos.resumen.cobrados &&
              c.datos.resumen.cobrados.totales
            ? c.datos.resumen.cobrados.totales
            : false;
        return {
          ...c,
          periodo:
            (!!c.inicio
              ? moment.unix(c.inicio).format("DD-MM-YYYY HH:mm")
              : "-") +
            " / " +
            (!!c.fin ? moment.unix(c.fin).format("DD-MM-YYYY HH:mm") : "-"),
          total: !!total ? mostrarMoneda(total.total) : mostrarMoneda(0),
        };
      });
    },
  },
  methods: {
    goPdf(item) {
      window.open(item.ficheroCierre, "_blank");
    },
    getZCierres() {
      this.loading = true;
      return this.$store
        .dispatch("zcierres/getZCierres")
        .finally(() => (this.loading = false));
    },
  },
  mounted() {
    this.getZCierres();
  },
};
</script>

<style>
</style>